import React from 'react';
import AccountsOrigin from '../../../AccountsOrigin/AccountsOrigin';
import CardBankPayout from '../../../CardBankPayout/CardBankPayout';

import FieldBold from '../../../Fields/FieldBold/FieldBold';

import classes from './BankAccounts.module.scss';
import { accountSubTypeLabelObject, findDruoIdWithBankIdMelo } from '../../../../store/catalogs/banks';
import utils from '../../../../services/utils';

const BankAccounts = ({ accountsBanks, methodForPay }) => {
  const {
    bankId,
    bankAccountType,
    bankAccountNumber,
    destinyBankOwnerName,
    destinyBankOwnerIdentificationTypeLabel,
    destinyBankOwnerIdentificationNumber,
    sourceAccounts
  } = accountsBanks;

  return (
    <div className={classes.content}>
      <span className='semibold-18'>Cuentas de banco</span>
      <div className={classes.fields}>
        <FieldBold title='CUENTA DESTINO'>
          <CardBankPayout
            bankId={bankId ? findDruoIdWithBankIdMelo(bankId) : bankId}
            subtypeLabel={accountSubTypeLabelObject[bankAccountType]}
            bankLast4Digits={bankAccountNumber ? utils.getLast4Digit(bankAccountNumber) : bankAccountNumber}
            name={destinyBankOwnerName}
            isButton={false}
            identification={`${destinyBankOwnerIdentificationTypeLabel} ${destinyBankOwnerIdentificationNumber}`}
          />
        </FieldBold>
      </div>
      <AccountsOrigin
        isShowTotal={true}
        sourceAccounts={(sourceAccounts || []).map(sourceAccount => ({
          ...sourceAccount,
          bankId: sourceAccount.sourceBankDruoId,
          subtypeLabel: sourceAccount.sourceBankAccountTypeLabel,
          bankLast4Digits: sourceAccount.sourceBankAccountNumber,
          value: sourceAccount.value
        }))}
        methodForPay={methodForPay}
      />
    </div>
  );
};

export default BankAccounts;
